/* eslint-disable react/jsx-key */
import React from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Grid } from "@material-ui/core";

const RateOfInterest = ({ornamentObj,classes }) => {

  const interestRate = (index) =>{
    const interestRate = Number(ornamentObj?.loanSchemeInterestRateMap?.[index] / 12)?.toFixed(2) + "% PM (" +  ornamentObj?.loanSchemeInterestRateMap?.[index] +  "% PA)"
    return (
                    <label>
                      {interestRate}
                    </label>
    )
  }
  return (
      <GridContainer justfly="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienrReview}>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <p style={{ marginBottom: 0 }}>
                    <b>Days</b>
                  </p>
                </GridItem>
                {ornamentObj?.loanSchemeInterestRateMap?.["1"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>0-30</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["2"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>31-60</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["3"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>61-90</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["4"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>91-120</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["5"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>121-150</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["6"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>151-180</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["7"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>181-210</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["8"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>211-240</label>
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["9"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <label>240-270</label>
                  </GridItem>
                )}
          </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienrReview}>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <p style={{ marginBottom: 0 }}>
                    <b>Interest Rate</b>
                  </p>
                </GridItem>
                
                {ornamentObj?.loanSchemeInterestRateMap?.["1"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                        {interestRate("1")}
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["2"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    {interestRate("2")}
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["3"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    {interestRate("3")}
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["4"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    {interestRate("4")}
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["5"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                     {interestRate("5")}
                  </GridItem>
                )}
                {ornamentObj?.loanSchemeInterestRateMap?.["6"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    {interestRate("6")}
                  </GridItem>
                )}
                 {ornamentObj?.loanSchemeInterestRateMap?.["7"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                     {interestRate("7")}
                  </GridItem>
                )}
                 {ornamentObj?.loanSchemeInterestRateMap?.["8"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                   {interestRate("8")}
                  </GridItem>
                )}
                 {ornamentObj?.loanSchemeInterestRateMap?.["9"] && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    {interestRate("9")}
                  </GridItem>
                )}
                </Grid>
            </Grid></Grid>
      </GridContainer>
  );
};

RateOfInterest.propTypes = {
  ornamentObj: PropTypes.object,
};

export default RateOfInterest;
